
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/herkunft/gebiet",
      function () {
        return require("private-next-pages/herkunft/gebiet.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/herkunft/gebiet"])
      });
    }
  